class PartnerApiDataStore {
  constructor() {
  /**
   * @type {PaymentJson}
   */
  this.partnerApiData = {};
  }

  setPartnerApiData(partnerApiData) {
    this.partnerApiData = partnerApiData;
  }

  /**
   * @returns {PaymentJson} 
   */
  getPartnerApiData() {
    return this.partnerApiData;
  }
  

}

export const PartnerApiDataStoreInstance = new PartnerApiDataStore();
